import styled from '@emotion/styled'

import CircularLabelButton from '@/components/CircularLabelButton'
import WysiwygBase from '@/components/Wysiwyg'

import {
  mediaMax,
  sectionTitle
} from '@/styles/mixins'

export const Wrapper = styled.div`
  // margin-top: 100px; //header height
  width: 100%;
  height: 80vh;
  position: relative;
  background-image: linear-gradient(to top, #000000c4, transparent),url(${props => props.img});
  background-size: cover;
  background-position: center;
  ${mediaMax.xs} {
    width: 100%;
    height: 60vh;
    background-image: linear-gradient(to top, #000000c4, transparent),url(${props => props.img});
  }
`

export const CircularButton = styled(CircularLabelButton)`
  position: absolute;
  left: 3rem;
  bottom: 3rem;
  z-index: 2;
  transform: scale(1.2);
  ${mediaMax.lg} {
    transform: scale(1);
    left: 3rem;
    bottom: 3rem;
  }
  ${mediaMax.xs} {
    z-index: -1;
    visisbility: none;
  }
`

export const ButtonContainer = styled.div`
  max-width: 280px;
`

export const Container = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5vw;
`

export const Title = styled.h1`
  ${sectionTitle};
  margin-bottom: 3.4rem;
  color: ${({ theme }) => theme.colors.white};
`

export const Introduction = styled(WysiwygBase)`
  font-weight: bold;
  color: ${({ theme }) => `${theme.colors.white}d9`};
  line-height: 1.875rem;
  margin-bottom: ${({ theme }) => theme.spacing.small};
  width: 60%;
  &.uppercase{
    line-height: 1.625rem;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
    ${mediaMax.xs} {
      line-height: 3.0rem;
    }
    ${mediaMax.md} {
      margin-bottom: ${({ theme }) => theme.spacing.small};
    }
  }

  ${mediaMax.md} {
    width: 80%;
  }

  ${mediaMax.xs} {
    width: 95%;
  }
`
